const STATS = [
  { n: '~100',  l: 'Stocks analyzed daily' },
  { n: '4',     l: 'Projection periods tracked' },
  { n: '72%',   l: 'Hit or Beat rate (last 90d)' },
  { n: 'Daily', l: 'Accountability — every issue' },
];

export default function StatsBar() {
  return (
    <div className="stats-bar">
      <div className="stats-in">
        {STATS.map((s, i) => (
          <div key={i} className="stat-item">
            <span className="stat-n">{s.n}</span>
            <span className="stat-l">{s.l}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
